import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

export function GetBuyerId(item: SmartSendItemApiModel): string {
  return item?.Recipient?.Meta['buyerId']?.Value;
}
